
import {
    Mixins,
    Component
} from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";
import MerchantDialecticForm from "./components/merchantForm.vue";
import MerchantTypeConfig from "./components/merchantTypeConfig.vue";

import {
    getIntelligentType,
    getMerchantIntelligentTypeList,
    getMerchantIntelligentList,
    updateMerchantIntelligentStatus,
    deleteMerchantIntelligent
} from "@/api/dialectic";

import { GenderEnum2 } from "@/enum/symptoms.enum";

@Component({ name: 'dialectic-merchant',
    components: {
        ETable, MerchantDialecticForm, MerchantTypeConfig
    }
})
export default class MerchantDialecticList extends Mixins(loading, tablePagination, Resize) {

    // 品牌方名称与ID，从路由 query 获取
    brandName = (this.$route.query.brandName as string) || "";
    merchantId = (this.$route.query.merchantId as string) || "";

    // 当前激活的 tab，默认展示智能评估列表
    activeTab = "list";

    tabListSurplusHeight = 20;

    queryForm = {
        symptomName: "",
        symptomType: "",
        symptomStatus: "",
    }

    columns = [
        {
            label: "名称",
            prop: "symptomName",
            minWidth: 150,
            align: "center"
        },
        {
            label: "适用人群",
            prop: "",
            minWidth: 100,
            align: "center",
            formatter: (row) => {
                return GenderEnum2[row.gender];
            }
        },
        {
            label: "状态",
            prop: "status",
            width: 150,
            align: "center"
        },
        {
            label: "操作人",
            prop: "modifiedBy",
            width: 150,
            align: "center"
        },
        {
            label: "最后操作时间",
            prop: "modifiedTime",
            minWidth: 180,
            align: "center"
        },
        {
            label: "操作",
            prop: "action",
            fixed: "right",
            width: 160,
            align: "center"
        },
    ]
    tableData = [{
    }];

    dialogVisible = false;
    dialogForm = {
        id: "",
        symptomName: "",
        symptomStatus: 1,
        symptomType: "",
        gender: 0
    };

    // 品牌方类型配置列表（通用类型 + 个性类型），用于类型配置 tab
    typeList = [];

    // 搜索/表单"选择类型"下拉（getIntelligentType 带 merchantId，平台类目 + 个性类目）
    symptomTypeOptions = [];


    mounted(){
        this.windowResize();
        this.getMerchantTypeList();
        this.getIntelligentTypeOptions();
        this.getData();
    }

    getData() {
        this.showLoading();
        getMerchantIntelligentList({
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            merchantId: this.merchantId,
        }).then(res => {
            this.hideLoading();
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
        }).finally(() => {
            this.hideLoading();
        });
    }

    handleSearch() {
        this.resetCurrent();
        this.getData();
    }

    handleEdit(row = {} as any) {
        this.dialogVisible = true;
        if (row.id) {
            // 编辑自建项：回填表单，列表 status 映射到 symptomStatus 以便保存时保留当前状态
            this.$nextTick(() => {
                Object.assign(this.dialogForm, {
                    id: row.id,
                    symptomName: row.symptomName,
                    symptomType: row.symptomType,
                    gender: row.gender,
                    symptomStatus: Number(row.status),
                });
            })
        } else {
            // 新增自建项：默认启用
            this.dialogForm = { id: "", symptomName: "", symptomStatus: 1, symptomType: "", gender: 0 }
        }
    }

    // NOTE: 状态切换，status 传当前状态，后端取反
    handleStatusChange(row) {
        updateMerchantIntelligentStatus({
            merchantId: this.merchantId,
            id: row.id,
            customFlag: row.customFlag,
            status: row.status,
        }).then(() => {
            this.$message.success("操作成功");
            this.getData();
        })
    }

    // NOTE: 仅自建项(customFlag=1)可删除
    handleDelete(row) {
        this.$confirm(`确定删除【${row.symptomName}】吗？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
            deleteMerchantIntelligent({ merchantId: this.merchantId, id: row.id }).then(() => {
                this.$message.success("删除成功");
                this.getData();
            })
        }).catch(() => {
            // NOTE: 用户取消删除，忽略
        })
    }

    // 品牌方类型配置列表（通用+个性，不分页）
    getMerchantTypeList() {
        getMerchantIntelligentTypeList({ merchantId: this.merchantId }).then(res => {
            this.typeList = res.data || [];
        })
    }

    // 搜索/表单类型下拉，带 merchantId 返回平台类目 + 品牌方个性类目
    getIntelligentTypeOptions() {
        getIntelligentType({ merchantId: this.merchantId }).then(res => {
            this.symptomTypeOptions = res.data || [];
        })
    }

    // 类型配置 tab 新增/编辑后，刷新类型列表与下拉（改名会同步到挂在该类目下的自建评估名称）
    handleTypeRefresh() {
        this.getMerchantTypeList();
        this.getIntelligentTypeOptions();
    }

}
